import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { StyledLink } from './Link.styles';
import { Icon } from '..';

var ExternalLinkIcon = function ExternalLinkIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48M336 64h112v112M224 288L440 72",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "ionicon-fill-none ionicon-stroke-width"
  }));
};

export var Link = forwardRef(function (_ref, ref) {
  var isExternal = _ref.isExternal,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      rest = _objectWithoutProperties(_ref, ["isExternal", "children", "size"]);

  return isExternal ? /*#__PURE__*/React.createElement(StyledLink, Object.assign({
    ref: ref,
    target: "_blank",
    rel: "noopener noreferrer",
    size: size
  }, rest), children, /*#__PURE__*/React.createElement(Icon, {
    icon: ExternalLinkIcon,
    ml: size === 'lg' ? 2 : 1,
    inline: true
  })) : /*#__PURE__*/React.createElement(StyledLink, Object.assign({
    ref: ref,
    children: children,
    size: size
  }, rest));
});